// Angular
import { Component } from '@angular/core';
// AG-Grid
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
	selector: 'cv-custom-date-cell',
	templateUrl: './custom-date-cell.component.html',
	styleUrls: ['./custom-date-cell.component.scss']
})
export class CustomDateCellComponent implements ICellRendererAngularComp {
	public cellValue: any;

	constructor() {
		//
	}

	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		if (params.value) {
			this.cellValue = new Date(params.value).toUTCString();
		}
	}

	/**
	 * Put back the value
	 * @param params
	 */
	refresh(params: ICellRendererParams): boolean {
		this.cellValue = params;
		return true;
	}

}
